import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  title: {
    marginBottom: "20px",
  },
  descriptionHeading: {
    marginBottom: "20px",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: "20px",
    marginBottom: "10px",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  generateButton: {
    marginBottom: "10px",
    width: "142px",
    "& .MuiTypography-root": {
      padding: "0px 40px !important",
    },
  },
  apps: {
    gap: theme.spacing(2.5),
    marginBottom: theme.spacing(2.5),
  },
  app: {
    width: "100%",
    border: "1px solid",
    borderColor: theme.palette.border.default,
    padding: "16px",
    display: "flex",
    alignItems: "center",
    gap: "24px",
    boxShadow: `4px 4px 4px 0px ${theme.palette.boxShadow.default}`,
    borderRadius: "0px",
  },
  appIcon: {
    width: "50px",
    height: "50px",
  },
  appName: {
    marginBottom: theme.spacing(0.5),
  },
  helpLink: {
    color: theme.palette.blue.main,
    marginTop: theme.spacing(0.5),
  },
}));

export const styles = {
  closeIcon: {
    color: "icon.secondary",
  },
  content: {
    width: "486px",
  },
  confirmButton: {
    width: "142px",
  },
  cancelButton: {
    width: "127px",
  },
};
